// src/components/Navbar.tsx
import { useLocation, Link } from "react-router-dom";

export default function Navbar() {
  const { pathname } = useLocation();
  const normalizedPath = pathname.toLowerCase();
  const isActive = (target: string) => normalizedPath === target.toLowerCase();

  const activeClasses = "bg-gray-200 text-black";
  const inactiveClasses = "bg-black hover:bg-gray-200 hover:text-black";
  const smallLinkBase =
    "flex-1 border border-black rounded-none transition-colors duration-200 flex items-center justify-center z-10 whitespace-nowrap antialiased";
  const largeButtonBase =
    "border border-black rounded-none px-12 py-1.5 mb-0 transition-colors duration-200 whitespace-nowrap antialiased";

  const getSmallLinkClasses = (target: string, extra = "") =>
    `${smallLinkBase} ${isActive(target) ? activeClasses : inactiveClasses} ${extra}`;

  const getLargeButtonClasses = (target: string, extra = "") =>
    `${largeButtonBase} ${extra} ${isActive(target) ? activeClasses : inactiveClasses}`;

  return (
    <nav className="fixed top-0 left-0 w-full bg-white z-50">
      {/* top border */}
      <div className="flex flex-row h-2 md:h-3 justify-center items-center bg-black"></div>
      {/** For small screens and tablets*/}
      
      {/* main box will raze line and buttons shrinking nav height*/}
      <div className="md:hidden flex flex-row h-[clamp(3.5rem,10vw,9.8rem)] sm:h-19.5 justify-center relative ">        {/*top box section */}
        <div className="flex  text-zinc-200  pb-0 flex-col justify-between text-lg "> 
          {/* Lets face it logo */}
          <div className="relative h-[170px] basis-5/6 w-screen text-slate-700 ">
            <Link to="/" className="absolute inset-x-0 top-1/2 -translate-y-1/2  text-center font-extrabold 
            font-mak text-[clamp(52.5px,9.75vw,168px)] sm:text-[90px] mt-2.5 sm:mt-4 antialiased">
                Let's Face It
            </Link>
          </div>
        </div>
      </div>
      {/*Buttons row on small to medium screen */}
      <div className="md:hidden grid grid-cols-4 text-zinc-200 h-8 sm:h-11  t-3 text-[22px] xsm:text-[22px] sm:text-[25px]">
        <Link to="/book" className={getSmallLinkClasses("/book", "border-l-0!")}>
          Book
        </Link>
        <Link to="/services" className={getSmallLinkClasses("/services")}>
          <span className="hidden xsm:inline">Services</span>
          <span className="xsm:hidden">Services</span>
        </Link>
        <Link to="/our_story" className={getSmallLinkClasses("/our_story")}>
          <span className="hidden xsm:inline">Our Story</span>
          <span className="xsm:hidden">Story</span>
        </Link>
        <Link to="/work" className={getSmallLinkClasses("/work", "border-r-0!")}>
          Work
        </Link>  
      </div>

      {/** For large screens*/}
      {/* main box will raze line and buttons shrinking nav height*/}
      <div className="hidden md:flex md:flex-row md:h-[clamp(6rem,11.3vw,8rem)] md:justify-center md:py-2 md:relative overflow-hidden">
        {/* left side section */}
        <div className="sm:flex basis-1/6 text-zinc-200 pt-6 pb-0 flex-col justify-between text-xl">
          {/* line near top middle left side */}
          <div className="h-0.5 bg-black  w-3/4"></div>
          {/* row with buttons in it book and products  left side*/}
          <div className="flex flex-row">  
          <Link to="/book">
            <button className={getLargeButtonClasses("/book", "ml-2 mr-2")}>
              Book
            </button>
          </Link> 
          <Link to="/services"> 
            <button className={getLargeButtonClasses("/services", "mr-2")}>
              Services
            </button>
          </Link>
          </div>
        </div>
        {/* Lets face it logo */}
        <div className="relative h-[170px] sm:basis-4/6 sm:w-screen text-slate-700 -mt-3 ">
        <Link to="/" className="absolute inset-x-0 top-[52%] -translate-y-1/2 text-center font-extrabold 
                  font-mak text-sm md:text-[clamp(95px,6.75vw,160px)] lg:text-[clamp(95px,7.5vw,160px)] antialiased">
            Let's Face It
        </Link>
        </div>
        {/* right side section */}
        <div className=" sm:flex basis-1/6 text-zinc-200 pt-6  flex-col justify-between text-xl">  
          {/* line near top middle right*/}
          <div className="h-0.5 bg-black  w-3/4 ml-auto"></div>

          {/* Row with buttons in it team and contact right side*/}
          <div className="flex flex-row ">
            <Link to="/our_story">
              <button className={getLargeButtonClasses("/our_story", "ml-2 mr-2")}>
                Our Story
              </button>
            </Link>
            <Link to="/work">
              <button className={getLargeButtonClasses("/work", "mr-2")}>
                Work
              </button>
            </Link>
          </div>
        </div>
      </div>
      {/* line at bottom */}
      <div className="hidden md:flex relative flex-row h-3 mt-0 bg-black"></div>
    </nav>
  );
}